import React, { useState } from 'react';
import { Box, FormControlLabel, IconButton, Paper, Stack, Switch, Tooltip, Typography } from '@mui/material';
import { LayersRounded as LayersIcon } from '@mui/icons-material';
import type { ExecutionMapLayerVisibility } from '../map/executionMapTypes';

interface ExecutionMapLayerControlsProps {
  value: ExecutionMapLayerVisibility;
  onChange: (value: ExecutionMapLayerVisibility) => void;
}

const OPTIONS: Array<{ key: keyof ExecutionMapLayerVisibility; label: string }> = [
  { key: 'plannedRoutes', label: 'Planned routes' },
  { key: 'actualRoutes', label: 'Actual routes' },
  { key: 'points', label: 'Points' },
  { key: 'sequences', label: 'Sequence badges' },
  { key: 'vehicles', label: 'Vehicles' },
  { key: 'exceptions', label: 'Exception emphasis' },
];

const ExecutionMapLayerControls: React.FC<ExecutionMapLayerControlsProps> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  return (
    <Box sx={{ position: 'absolute', right: 12, top: 12, zIndex: 29 }}>
      <Tooltip title="Execution map layers">
        <IconButton
          aria-label="Execution map layers"
          onClick={() => setOpen((current) => !current)}
          sx={{ width: 38, height: 38, bgcolor: 'background.paper', boxShadow: 3, '&:hover': { bgcolor: 'background.paper' } }}
        >
          <LayersIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {open ? (
        <Paper elevation={8} sx={{ position: 'absolute', right: 0, top: 46, width: 218, p: 1.25, borderRadius: 2 }}>
          <Typography variant="overline" fontWeight={800} color="text.secondary">Map layers</Typography>
          <Stack sx={{ mt: 0.4 }}>
            {OPTIONS.map((option) => (
              <FormControlLabel
                key={option.key}
                control={(
                  <Switch
                    size="small"
                    checked={value[option.key]}
                    onChange={(event) => onChange({ ...value, [option.key]: event.target.checked })}
                    inputProps={{ 'aria-label': option.label }}
                  />
                )}
                label={option.label}
                sx={{ mx: 0, '& .MuiFormControlLabel-label': { fontSize: 12 } }}
              />
            ))}
          </Stack>
        </Paper>
      ) : null}
    </Box>
  );
};

export default ExecutionMapLayerControls;
